import { ImmutableMap } from '@/lib/immutable/ImmutableMap'
import { IAction } from '@/redux/actions/action-helpers'
import { TripTypes } from '@/redux/actions/actions.types'
import { ApplicationState } from '@/redux/stores/types'

export function tripOrdersReducer(state: ApplicationState['tripOrders'] = new ImmutableMap(), action: IAction) {
	if (action.type !== TripTypes.GetBookingStatus.SUCCESS) {
		return state
	}

	return state.set(action.requestPayload.tripId, action.payload.trip_fees)
}
